import http from "./http-common";

const getAll = (opts = {}) => {
  return http.get("/get-statistics", opts);
};

const StatsService = {
  getAll
};

export default StatsService;